import { FormBlocker, FormBlockerElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

import { getBlockerAction } from '../FlowProvider/hooks/useBlockerAction'

function trimSpacerElementsFromEnd(elements: FormBlockerElement[] = []) {
  const trimmedElements = [...elements]

  while (trimmedElements.length > 0 && trimmedElements[trimmedElements.length - 1].spacer_element) {
    trimmedElements.pop()
  }

  return trimmedElements
}

// Clean up unsupported actions. We do not want to show buttons with unsupported actions,
// nor do we want extra bottom spacer elements to remain if we don't show buttons.
export function removeUnsupportedActions(blocker: FormBlocker) {
  const isPrimaryActionSupported = blocker.primary_action && getBlockerAction(blocker.primary_action).isSupported
  const isSecondaryActionSupported = blocker.secondary_action && getBlockerAction(blocker.secondary_action).isSupported
  const hasSupportedActions = Boolean(isPrimaryActionSupported || isSecondaryActionSupported)

  return {
    ...blocker,
    primary_action: isPrimaryActionSupported ? blocker.primary_action : undefined,
    secondary_action: isSecondaryActionSupported ? blocker.secondary_action : undefined,
    elements: hasSupportedActions ? blocker.elements : trimSpacerElementsFromEnd(blocker.elements),
  }
}
